'use client'

import { Divider, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'

import SignUpButton from '../../../components/SignUpButton/SignUpButton'
import ConvertButton from '../../../components/ConvertButton/ConvertButton'

const MobileHero = () => {
  const translate = useTranslate('business.homepage')
  const { user } = useSession()
  const isUserLoggedIn = !!user

  return (
    <div className="content-block u-mobiles-only">
      <div className="business-accounts-homepage__hero-heading--mobile">
        <Spacer size="x2-large" />
        <Text as="span" width="parent" html>
          <span className="c-text--responsive-large-heading">
            {isUserLoggedIn
              ? translate('hero.title.logged_in')
              : translate('hero.title.logged_out')}
          </span>
        </Text>
        <Spacer size="large" />
        <Text as="span" width="parent">
          <span className="c-text--responsive-large-body">
            {isUserLoggedIn
              ? translate('hero.subtitle.logged_in')
              : translate('hero.subtitle.logged_out')}
          </span>
        </Text>
        <Spacer size="x-large" />

        {isUserLoggedIn ? (
          <ConvertButton text={translate('actions.convert_account')} />
        ) : (
          <SignUpButton text={translate('actions.sign_up')} />
        )}
        <Spacer size="x2-large" />
        <Divider />
      </div>
    </div>
  )
}

export default MobileHero
